<template>
  <div class="row no-gutters catalog-nav-component cnc">
    <div class="col-3 cnc__nav">
      <catalog-menu-listing :current-catalog="currentCatalog" />
    </div>
    <div class="col-9 cnc__content">
      <div class="cnc__preview">
        <template v-if="IsNotNullOrUndefined(this,'CatalogRoot')">
          <catalog-preview
            v-for="category in CatalogRoot"
            v-show="currentCatalog.id == category.Id"
            :key="category.Id"
            ref="catalogPreview"
            :category="category"
          />
        </template>
      </div>
      <div class="cnc__shop-all">
        <router-link :to="currentCatalog.link" class="cnc__shop-all-link hmmc__menu-item">
          Shop All {{ currentCatalog.name }} &gt;&gt;
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import CatalogMenuListing from "@/components/Catalog/MegaMenu/CatalogMenuListing"
  import CatalogPreview from "@/components/Catalog/MegaMenu/CatalogPreview"
  import { mapGetters }       from "vuex"

  export default {
    components: {
      CatalogMenuListing,
      CatalogPreview
    },
    data: function() {
      return {
        currentCatalog: {
          name: "",
          link: "",
          id: undefined
        }
      }
    },
    computed: {
      ...mapGetters(["CatalogRoot"])
    },
    watch: {
      CatalogRoot: function (val) {
      }
    }
  }

</script>
<style lang="scss">
.cnc {
  max-height: 75vh;
}
.cnc__nav,
.cnc__content {
  display: flex;
  flex-direction: column;
  max-height: 75vh;
}
.cnc__preview {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}
.cnc__shop-all {
  flex-shrink: 0;
  padding: 6px 15px 8px;
  text-align: right;
}
.cnc__shop-all-link {
  font-family: Calibri, Tahoma, Arial, Helvetica, sans-serif;
  font-size: 24px;
  line-height: 1.5;
  &:hover {
    color: #000;
    background: transparent;
  }
}
</style>
